import React from "react";
import { ActivityModule, Modules } from "../../../constants/Module";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import CreatorDetails from "./creatorDetails";
import { withTranslation } from "react-i18next";

const AddMilestone = ({ item,t }) => {

    return (
        <React.Fragment>
            <div className="mx-2">
                {item.module === ActivityModule.CHANGE_REQUEST_ITEM &&
                    <div>
                        <strong> {t('Add')} {ucFirst(Modules.MILESTONE)} ({item?.payload?.payload?.name}) </strong>
                         {item?.event === Action.CREATE ? t('was added to') : t('was removed from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
                {item?.module === ActivityModule.MILESTONE &&
                    <div>
                        <strong> {ucFirst(Modules.MILESTONE)} ({item?.payload?.name}) </strong>
                        {t('was created from')} <strong>{t('change request')} ({item?.payload?.changeRequest?.uniqueChangeRequestId})</strong> {t('to')} <strong>{t('startup')} ({item?.payload?.project?.uniqueProjectId})</strong>
                        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default withTranslation()(AddMilestone);
